import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import MobDiscover from "@/views/MobDiscover";
import MobTerms from "@/views/MobTerms";
import MobPrivacy from "@/views/MobPrivacy";
import MobSupport from "@/views/MobSupport";
import MerchantDetails from "@/views/MerchantDetails";
import Business from "@/views/Business";
import MerchantContactSuccess from "@/views/MerchantContactSuccess";
import Privacy from "@/views/Privacy";
import MerchantTerms from "@/views/MerchantTerms";
import IframeEducation from "@/views/IframeEducation";
import Terms from "@/views/Terms";
import CategoryView from "../views/CategoryView";
import Careers from "../views/Careers";
import About from "../views/About";
import Press from "../views/Press";
import MobCategoryView from "../views/MobCategoryView";
import MobCategoryViewKollection from "../views/MobCategoryViewKollection";
import MobChannelViewOnline from "../views/MobChannelViewOnline";
import MobChannelViewSocial from "../views/MobChannelViewSocial";
import MobPromotionView from "../views/MobPromotionView.vue";
import MobDeals from "../views/MobDeals";
import MobDealsExploreView from "../views/MobDealsExploreView"
import MobCreatedForYou from "../views/MobCreatedForYou";

import MobViewAllCategories from "../views/MobViewAllCategories.vue";
import SwaggerUI from "../views/SwaggerUI.vue"

// Testing Enviroments
import MobhotProducts from "@/views/MobhotProducts"
import MobViewProducts from "@/views/MobViewProducts"
import Education from "@/views/Education"
import EducationalView from "@/views/EducationalView"
import PaymentSchemeLearn from "@/views/PaymentSchemeLearn"

import BlackFridaySale from "@/views/BlackFridaySale"

import WelcomePage from "@/views/WelcomePage.vue"
import MerchantSignUp from "@/views/MerchantSignUp.vue"

const routes = [
  {
    path: "/press",
    name: "Press",
    component: Press,
  },
  {
    path: "/careers",
    name: "Careers",
    component: Careers,
  },

  {
    path: "/about",
    name: "About",
    component: About,
  },

  {
    path: "/category",
    name: "CategoryView",
    component: CategoryView,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
  },
  {
    path: "/terms",
    name: "Terms",
    component: Terms,
  },
  
  {
    path: "/customer-education",
    name: "EducationalView",
    component: EducationalView,
  },
  {
    path: "/payment-scheme-learn",
    name: "PaymentSchemeLearn",
    component: PaymentSchemeLearn,
  },
  {
    path: "/education",
    name: "Education",
    component: Education,
  },
  {
    path: "/iframe-education",
    name: "Iframe Education",
    component: IframeEducation,
  },
  {
    path: "/merchant-terms",
    name: "Merchant Terms",
    component: MerchantTerms,
  },
  {
    path: "/merchantContactSuccess",
    name: "MerchantContactSuccess",
    component: MerchantContactSuccess,
  },
  // Previous Verion of Hot Products 
  {
    path: "/blackFridaySale",
    name: "BlackFridaySale",
    component: BlackFridaySale,
  },
  {
    path: "/koko/api/SwaggerUI",
    name: "SwaggerUI",
    component: SwaggerUI,
  },
  {
    path: "/m/products",
    name: "MobViewProducts",
    component: MobViewProducts,
    meta: { reuse: false },
  },
  {
    path: "/m/hotProducts",
    name: "MobhotProducts",
    component: MobhotProducts,
    meta: { reuse: false },
  },
  {
    path: "/m/discover",
    name: "MobDiscover",
    component: MobDiscover,
    meta: { reuse: false },
  },
  {
    path: "/m/category",
    name: "MobCategoryView",
    component: MobCategoryView,
    meta: { reuse: false },
  },

  {
    path: "/m/kollection",
    name: "MobCategoryViewKollection",
    component: MobCategoryViewKollection,
    meta: { reuse: false },
  },

  {
    path: "/m/channel/online",
    name: "MobChannelViewOnline",
    component: MobChannelViewOnline,
    meta: { reuse: false },
  },
  {
    path: "/m/channel/social",
    name: "MobChannelViewSocial",
    component: MobChannelViewSocial,
    meta: { reuse: false },
  },
  {
    path: "/m/terms",
    name: "MobTerms",
    component: MobTerms,
    meta: { reuse: false },
  },
  {
    path: "/m/deals",
    name: "MobDeals",
    component: MobDeals,
    meta: { reuse: false },
  },
  {
    path: "/m/alldeals",
    name: "MobDealsExploreView",
    component: MobDealsExploreView,
    meta: { reuse: false },
  },
  {
    path: "/m/categories",
    name: "MobViewAllCategories",
    component: MobViewAllCategories,
    meta: { reuse: false },
  },

  {
    path: "/m/foryou",
    name: "MobCreatedForYou",
    component: MobCreatedForYou,
    meta: { reuse: false },
  },

  // promotion was added for the wild card promo

  {
    path: "/m/promotion",
    name: "MobPromotionView",
    component: MobPromotionView,
    meta: { reuse: false },
  },
  {
    path: "/m/support",
    name: "MobSupport",
    component: MobSupport,
    meta: { reuse: false },
  },
  {
    path: "/m/privacy",
    name: "MobPrivacy",
    component: MobPrivacy,
    meta: { reuse: false },
  },
  {
    path: "/business",
    name: "Business",
    component: Business,
    meta: { reuse: false },
  },
  {
    path: "/m/merchant/:id",
    name: "MerchantDetails",
    component: MerchantDetails,
    meta: { reuse: false },
  },
  {
    path: "/welcome",
    name: "WelcomePage",
    component: WelcomePage
    
  },
  {
    path: "/merchant-sign-up",
    name: "MerchantSignUp",
    component: MerchantSignUp,
    meta: { reuse: false },

  },

  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
];

const router = createRouter({
  mode: history,
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
});

router.beforeEach((to, from) => {
  console.log(to, from);
  // ...
  // explicitly return false to cancel the navigation
  window.scrollTo(0, 0);
});

export default router;
